import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '../styles/Booking.css';

const Booking = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    date: '',
    time: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loadingServices, setLoadingServices] = useState(true);

  // Get current language
  const currentLang = i18n.language || 'pt';

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get('/api/services');
      if (response.data.success) {
        // Get only bookable services
        const bookableServices = response.data.allServices.filter(s => s.bookingEnabled);
        setServices(bookableServices);
      }
      setLoadingServices(false);
    } catch (error) {
      console.error('Error fetching services:', error);
      setLoadingServices(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      await axios.post('/api/bookings', formData);
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', service: '', date: '', time: '', message: '' });
      
      // Clear success message after 5 seconds
      setTimeout(() => setStatus(''), 5000);
    } catch (error) {
      console.error('Booking error:', error);
      setStatus('error');
      
      // Clear error message after 5 seconds
      setTimeout(() => setStatus(''), 5000);
    }
  };

  return (
    <div className="booking-page">
      <section className="booking-hero">
        <div className="container">
          <h1>{t('booking.title')}</h1>
          <p>{t('booking.subtitle')}</p>
        </div>
      </section>

      <section className="booking-form-section section">
        <div className="container">
          <div className="booking-container">
            <form onSubmit={handleSubmit} className="booking-form">
              <h2>{t('booking.form.service.label')}</h2>
              
              <div className="form-group">
                <label>{t('booking.form.service.label')}</label>
                <select 
                  name="service" 
                  value={formData.service} 
                  onChange={handleChange} 
                  required
                  disabled={loadingServices}
                >
                  <option value="">
                    {loadingServices 
                      ? (currentLang === 'pt' ? 'Carregando...' : 'Loading...') 
                      : t('booking.form.service.placeholder')
                    }
                  </option>
                  {services.map((service) => (
                    <option key={service._id} value={service.slug}>
                      {service.name[currentLang]} - €{service.price}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{t('booking.form.date.label')}</label>
                  <input 
                    type="date" 
                    name="date" 
                    value={formData.date}
                    onChange={handleChange}
                    min={new Date().toISOString().split('T')[0]}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>{t('booking.form.time.label')}</label>
                  <input 
                    type="time" 
                    name="time" 
                    value={formData.time}
                    onChange={handleChange} 
                    required 
                  />
                </div>
              </div>

              <div className="form-group">
                <label>{t('booking.form.name.label')}</label>
                <input 
                  type="text" 
                  name="name" 
                  placeholder={t('booking.form.name.placeholder')}
                  value={formData.name}
                  onChange={handleChange} 
                  required 
                />
              </div>

              <div className="form-group">
                <label>{t('booking.form.email.label')}</label>
                <input 
                  type="email" 
                  name="email" 
                  placeholder={t('booking.form.email.placeholder')}
                  value={formData.email}
                  onChange={handleChange} 
                  required 
                />
              </div>

              <div className="form-group">
                <label>{t('booking.form.phone.label')}</label>
                <input 
                  type="tel" 
                  name="phone" 
                  placeholder={t('booking.form.phone.placeholder')}
                  value={formData.phone}
                  onChange={handleChange} 
                  required 
                />
              </div>

              <div className="form-group">
                <label>{t('booking.form.message.label')}</label>
                <textarea 
                  name="message" 
                  placeholder={t('booking.form.message.placeholder')}
                  value={formData.message}
                  onChange={handleChange} 
                  rows="4"
                />
              </div>

              <button type="submit" className="btn btn-primary form-submit" disabled={status === 'submitting'}>
                {status === 'submitting' ? t('booking.form.submitting') : t('booking.form.submit')}
              </button>

              {status === 'success' && (
                <p className="form-message success">{t('booking.form.success')}</p>
              )}
              {status === 'error' && (
                <p className="form-message error">{t('booking.form.error')}</p>
              )}
            </form>

            <div className="booking-info">
              <div className="payment-info card">
                <h3>{t('booking.payment.title')}</h3>
                <p>{t('booking.payment.description')}</p>
                <p><small>{t('booking.payment.methods')}</small></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Booking;
